import Select from 'component/atom/forms/select/select/Select';
import Loader from 'component/atom/loader/Loader';
import NoData from 'component/molecules/Table/TableComponents/NoData/NoData';
import { azureEndpoints, scriptEndpoints } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import React, { useEffect, useMemo, useState } from 'react';
import VRCard from '../voice-recording-cards/VRCard';
import Paginator from 'component/molecules/Table/TableComponents/TablePaginator/Paginator';
import styles from './VoiceCardsContainer.module.scss';
import Container from 'component/atom/container/Container';
import Button from 'component/atom/forms/button/Button';
import _debounce from 'lodash/debounce';
import SearchInput from 'component/atom/forms/input/searchInput/SearchInput';
import { useParams } from 'react-router-dom';

const VoiceCardsContainer = ({ activeVoice }) => {
  const { id } = useParams();
  const [query, setQuery] = useState({
    pageSize: 10,
    pageNumber: 1,
    botId: id,
  });
  const [searchValue, setSearchValue] = useState(query?.searchBy || '');
  const [playingId, setPlayingId] = useState(null);
  const {
    data: voiceGallery,
    refetch,
    isFetchingVoiceGallery,
  } = useFetch(
    ['voiceGallery', id],
    scriptEndpoints.voiceGallery,
    {
      enabled: true,
    },
    query
  );
  const { data: languages } = useFetch(
    ['azureLanguages'],
    azureEndpoints.azureLanguages
  );
  const { data: personalityTypes } = useFetch(
    ['azurePersonalityTypes'],
    azureEndpoints.azurePersonalityTypes
  );
  const { data: gender } = useFetch(
    ['azureGender'],
    azureEndpoints.azureGender
  );
  const totalPages = Math.ceil(
    voiceGallery?.data?.totalCount / voiceGallery?.data?.pageSize
  );
  const hasData =
    voiceGallery?.data?.items?.length > 0 || voiceGallery?.data?.totalCount;
  const handlePageChange = (page) => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      pageNumber: page,
    }));
  };

  const handleReset = () => {
    setQuery({
      pageSize: 8,
      pageNumber: 1,
    });
  };
  const debouncedSearch = useMemo(
    () =>
      _debounce((value) => {
        setQuery({ ...query, searchBy: value });
      }, 500),
    [setQuery, query]
  );
  const handleSearchChange = (name, value) => {
    setSearchValue(value);
    debouncedSearch(value);
    setQuery((prevQuery) => ({
      ...prevQuery,
      pageNumber: 1,
    }));
  };
  useEffect(() => {
    refetch();
  }, [query]);

  useEffect(() => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      pageNumber: 1,
    }));
  }, [voiceGallery?.data?.totalCount]);

  const uniqueItems = voiceGallery?.data?.items?.filter(
    (item, index, self) => index === self.findLastIndex((t) => t.id === item.id)
  );

  if (isFetchingVoiceGallery) {
    return <Loader isComponent />;
  }
  return (
    <Container>
      <div className={styles['cont']}>
        <div className={styles['filter']}>
          <SearchInput
            classname={styles.search}
            onChange={handleSearchChange}
            value={searchValue}
            placeholder='Search'
          />

          <Select
            // label="Language"
            options={languages?.data}
            placeholder='Select Language'
            value={query.language}
            onChange={(e) => {
              setQuery((prevParams) => ({
                ...prevParams,
                language: e.target.value,
              }));
            }}
          />
          <Select
            // label="Gender"
            options={gender?.data}
            placeholder='Select Gender'
            value={query.gender}
            onChange={(e) => {
              setQuery((prevParams) => ({
                ...prevParams,
                gender: e.target.value,
              }));
            }}
          />
          <Select
            // label="Personality"
            options={personalityTypes?.data}
            placeholder='Select Personality'
            value={query.personality}
            onChange={(e) => {
              setQuery((prevParams) => ({
                ...prevParams,
                personality: e.target.value,
              }));
            }}
          />
        </div>
        <Button transparent label='Reset' onClick={handleReset} />
      </div>

      {isFetchingVoiceGallery ? (
        <Loader isComponent />
      ) : !hasData ? (
        <NoData />
      ) : (
        <div className={styles['cards']}>
          {uniqueItems?.map((item) => (
            <VRCard
              item={item}
              key={item.id}
              length={uniqueItems?.length > 5}
              playingId={playingId}
              setPlayingId={setPlayingId}
              activeVoice={activeVoice}
            />
          ))}
        </div>
      )}

      {voiceGallery?.data?.totalCount > 0 && (
        <Paginator
          onPageChange={handlePageChange}
          currentPage={query.pageNumber}
          totalPages={totalPages}
        />
      )}
    </Container>
  );
};

export default VoiceCardsContainer;
